import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, InternalCandidacyComment } from "@/types";

export function useDeleteInternalCandidacyComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      internalCandidacyCommentId,
    }: {
      candidacyId: string;
      internalCandidacyCommentId: number;
    }) => {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/internal-candidacy-comments/${internalCandidacyCommentId}`;
      const res = await guacHttpClient.delete<
        InternalCandidacyComment,
        HttpResponse<InternalCandidacyComment>
      >(path);

      return res.data;
    },
  });

  return mutation;
}
